import { Actions, ActionTypes } from '../actions/auth.action';

export interface IAuthState {
    action: string;
    authenticated: boolean;
    redirectUri: string;
}

const initialState: IAuthState = {
    action: "",
    authenticated: false,
    redirectUri: 'dashboard'
};

export function AuthReducer(state: IAuthState = initialState, action: Actions): IAuthState {
    switch (action.type) {
        case ActionTypes.LOGIN_USER:
            return {
                action: "LOGIN_USER",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.LOGIN_SUCCESS:
            return {
                action: "LOGIN_SUCCESS",
                authenticated: true,
                redirectUri: state.redirectUri
            };
        case ActionTypes.LOGIN_FAILURE:
            return {
                action: "LOGIN_FAILURE",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.SIGNUP_USER:
            return {
                action: "SIGNUP_USER",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.SIGNUP_SUCCESS:
            return {
                action: "SIGNUP_SUCCESS",
                authenticated: true,
                redirectUri: state.redirectUri
            };
        case ActionTypes.SIGNUP_FAILURE:
            return {
                action: "SIGNUP_FAILURE",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.SIGNOUT_SUCCESS:
            return {
                action: "SIGNOUT_SUCCESS",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.SIGNOUT_FAILURE:
            return {
                action: "SIGNOUT_FAILURE",
                authenticated: false,
                redirectUri: state.redirectUri
            };
        case ActionTypes.CHANGE_REDIRECT_URI:
            return {
                action: "CHANGE_REDIRECT_URI",
                authenticated: state.authenticated,
                redirectUri: action.payload
            }
        default:
            return state;
    }
}

export const isAuthenticated = (state: IAuthState) => state.authenticated;
export const getRedirectUri = (state: IAuthState) : string => state.redirectUri;
